// extracted by mini-css-extract-plugin
export var actions = "_3l-0";
export var actionsContainer = "_3l-5";
export var border = "_3l-1";
export var childFullHeight = "_3l-c";
export var collapse = "_3l-2";
export var content = "_3l-7";
export var contentChild = "_3l-b";
export var fullscreen = "_3l-9";
export var headerContainer = "_3l-3";
export var hidePadding = "_3l-8";
export var noScrollX = "_3l-d";
export var noScrollY = "_3l-e";
export var optOutTopPadding = "_3l-a";
export var pagePadding = "_3l-6";
export var profile = "_3l-f";
export var profileContainer = "_3l-g";
export var profileImage = "_3l-h";
export var profileMain = "_3l-i";
export var profileSubtitle = "_3l-k";
export var profileTitle = "_3l-j";
export var tabsWrapper = "_3l-4";
export var title = "_3l-l";